import "./newRoom.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import { useState } from "react";
import { roomInputs } from "../../formSource";
import useFetch from "../../hooks/useFetch";
import axios from "axios";
import Swal from 'sweetalert2'
import { useNavigate } from "react-router-dom";

const NewRoom = () => {
  let navigate = useNavigate();
  const [info, setInfo] = useState({});
  const [hotelId, setHotelId] = useState(undefined);
  const [rooms, setRooms] = useState([]);

  const { data, loading, error } = useFetch("/hotels");
  console.log("data=>",data);

  const handleChange = (e) => {
    console.log("e.target.id=>",e);
    setInfo((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };
  console.log(info)

  const handleClick = async (e) => {
    e.preventDefault();
    const roomNumbers = rooms.split(",").map((room) => ({ number: room }));
  console.log(roomNumbers)
    try {
      await axios.post(`https://dummy-app-link.herokuapp.com/api/rooms/${hotelId}`, { ...info, roomNumbers })
      .then(e=>{
         if(e.status==200){
          // setInfo('')
          Swal.fire({
            title: 'Room added successfully',
            icon: 'success',
            showConfirmButton: true,
            confirmButtonText: 'OK',
          // timer: 3000
          })
          setTimeout(() => {
          navigate("/rooms");
          }, 1000);
         }
        console.log("Rooms=>",e)
      })
    } catch (err) {
      console.log(err.response);
      Swal.fire({
        title: 'Error',
        text: err.response.request.statusText,
        position: 'top-end',
        icon: 'error',
      timer: 3000
      })
    }
  };

  console.log(info)
  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>Add New Room</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <form>
              {roomInputs.map((input) => (
                <div className="formInput" key={input.id}>
                  <label>{input.label}</label>
                  <input
                    id={input.id}
                    type={input.type}
                    placeholder={input.placeholder}
                    onChange={handleChange}
                
                  />
                </div>
              ))}
              <div className="formInput">
                <label>Rooms</label>
                <textarea
                  onChange={(e) => setRooms(e.target.value)}
                  placeholder="give comma between room numbers."
                />
              </div>
              <div className="formInput">
                <label>Choose a hotel</label>
                <select
                  id="hotelId"
                  onChange={(e) => setHotelId(e.target.value)}
                >
                  {loading
                    ? "loading"
                    : data &&
                      data.map((hotel) => (
                        <option key={hotel._id} value={hotel._id}>{hotel.name}</option>
                      ))}
                </select>
              </div>
              <button onClick={handleClick}>Send</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewRoom;
